import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../elements/Sidebar/';
import './index.scss';
import { useEffect, useState } from 'react';
import ScrollToTop from '../elements/ScrollToTop';

const Layout = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const nonTopTagPages = [
    '/about',
    '/contact',
    '/portfolio',
    '/writing',
    '/portfolio/advanced-robotics',
    '/portfolio/smear',
    '/portfolio/a-minimal-approach-to-fake-news-detection',
    '/writing/hume-on-violations-of-the-laws-of-nature',
    '/writing/rlg211-paper-1',
    '/writing/rlg211-paper-2',
    '/writing/rlg211-paper-3',
  ];
  let isNonTopTagPage = false;
  for (let i = 0; i < nonTopTagPages.length; i++) {
    if (location.pathname === nonTopTagPages[i]) {
      isNonTopTagPage = true;
      break;
    }
  }

  const nonBottomTagPages = [
    '/about',
    '/portfolio',
    '/writing',
    '/contact',
    '/portfolio/advanced-robotics',
    '/portfolio/first-innovation-developer-internship',
    '/portfolio/second-innovation-developer-internship',
    '/portfolio/smear',
    '/portfolio/shredr',
    '/portfolio/vexo-labs',
    '/portfolio/a-minimal-approach-to-fake-news-detection',
    '/writing/hume-on-violations-of-the-laws-of-nature',
    '/writing/rlg211-paper-1',
    '/writing/rlg211-paper-2',
    '/writing/rlg211-paper-3',
  ];
  let isNonBottompage = false;
  for (let i = 0; i < nonBottomTagPages.length; i++) {
    if (location.pathname === nonBottomTagPages[i]) {
      isNonBottompage = true;
      break;
    }
  }

  const [isWide, setIsWide] = useState(window.innerWidth > 1200);

  useEffect(() => {
    const handleResize = () => {
      setIsWide(window.innerWidth > 1200);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle('route-home', isHomePage);
    document.body.classList.toggle('route-home', isHomePage);

    return () => {
      document.documentElement.classList.remove('route-home');
      document.body.classList.remove('route-home');
    };
  }, [isHomePage]);

  return (
    <div className="App">
      <Sidebar />
      <div className={`page${isHomePage ? ' page--home' : ''}`}>
        <ScrollToTop />
        {(!isNonTopTagPage || isWide) && (
          <span className="tags top-tags">&lt;body&gt;</span>
        )}
        <Outlet />
        {!isNonBottompage && (
          <span className="tags bottom-tags">
            &lt;/body&gt;
            <br />
            <span className="bottom-tag-html">&lt;/html&gt;</span>
          </span>
        )}
      </div>
    </div>
  );
};

export default Layout;
